'use client';
import { JumboCard } from 'themes/jumbo/@jumbo/components';
import { Div } from 'themes/jumbo/@jumbo/shared';
import { Grid2 as Grid, Typography, Button, Chip, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import { useSelector } from 'react-redux';
import { trackEvent } from "components/Tracking";

const stateColor: any = {
    active: 'success',
    expired: 'error',
    pastdue: 'warning'
  }

const CurrentPlanCard = () => {
  const { ipn_name, subscription_status, expirationDate } = useSelector((state: any) => state.auth.data);
  return (
    <JumboCard contentWrapper contentSx={{ p: 3 }}>
      <Grid container spacing={3.75} className="mainGrid">
        <Grid  size={{ xs:6}}>
              <Div sx={{ display: 'flex', flexDirection: 'column', height: '75px' }}>
                <Div sx={{ flex: 1 }} className='blockTitle'>
                  <Typography color={'text.primary'} variant={'h6'} mb={1}>
                    Current Plan
                  </Typography>
                </Div>
                <Div sx={{ alignContent: 'center', pt: '5px', display: 'flex', gap:'8px', alignItems: 'center', justifyContent: {xs: 'center', sm:'center', md: 'flex-start', lg: 'flex-start', xl: 'flex-start'} }}>
                  <Typography color={'text.primary'} variant={'h3'} mb={1}>
                    { ipn_name }
                  </Typography>
                  <Chip
                    label={subscription_status.toUpperCase()}
                    size={'small'}
                    color={stateColor[subscription_status?.toLowerCase()] || 'warning'}
                    sx={{ mb: .5, transform: 'scale(.85)'}}
                  />
                </Div>
              </Div>
        </Grid>
        
        <Grid  size={{ xs:6}}>
              <Div sx={{ display: 'flex', height: '100%', flexDirection: 'column', justifyContent: 'flex-end' }} className='xsReverse'>
                <Div sx={{flex: 1, textAlign: 'right' }}>
                  <Tooltip title="Manage Plan" placement="top" arrow>
                    <Button
                        size={'small'}
                        variant={'outlined'}
                        component={Link} 
                        to="/profile"
                        style={{height: '25px', minWidth: 'auto'}}
                        onClick={(ev: any) => {
                            trackEvent("Dashboard", "Plan", "Manage")
                        }}
                      >
                        Manage
                      </Button>
                  </Tooltip>
                </Div>
                <Div sx={{ marginLeft: 'auto', display: 'flex', gap: '4px', flexDirection: 'column'}} className='inlineTitle'>
                  <Typography color={'text.secondary'} variant={'h6'} mb={0} sx={{display: 'flex'}}>
                    <EventNoteOutlinedIcon
                      sx={{ fontSize: { xs: 13, md: 18 }, mr: 1, mb: -0.5 }}
                    />
                    Expire:
                  </Typography>
                  <Typography color={'text.primary'} variant={'h6'} mb={0} sx={{ fontSize: { xs:11,md: 13 }}}>
                    { expirationDate }
                  </Typography>
                </Div>
              </Div>
        </Grid>
      </Grid>
    </JumboCard>
  );
};

export { CurrentPlanCard };
